//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        card: {
            type: Object
        },
        building: {
            type: Object
        }
    },
    computed: {
        show_vr_link () {
            const { activities } = this.building
            if (activities && activities.length) {
                return activities.indexOf('vr') > -1
            }
            return false
        },
        link () {
            if (this.card) {
                return `/building?building_id=${this.card.id}`
            }
        }
    },
    methods: {
        openVr () {
            wx.navigateTo({
                url: `/building/vr?building_id=${this.card.id}`
            })
        }
    }
}
